import { userRequest } from "./requestMethods";

// Thin wrappers around the platform `/api/addresses` address-book endpoints.
// All five require auth, so they go through `userRequest` (which attaches the
// bearer token from `persist:user`). Each returns the parsed `res.data`
// envelope, e.g. `{ success, addresses }` or `{ success, address }`.

/** List the authenticated customer's saved addresses (primary first). */
export const getAddresses = async () => {
  const res = await userRequest.get("/api/addresses");
  return res.data;
};

/**
 * Create a new saved address.
 * payload: { label, address, description, latLng:{lat,lng}, recipientPhone, isPrimary }
 */
export const createAddress = async (payload) => {
  const res = await userRequest.post("/api/addresses", payload);
  return res.data;
};

/** Update an existing saved address by id. */
export const updateAddress = async (id, payload) => {
  const res = await userRequest.put(`/api/addresses/${id}`, payload);
  return res.data;
};

/** Delete a saved address by id. */
export const deleteAddress = async (id) => {
  const res = await userRequest.delete(`/api/addresses/${id}`);
  return res.data;
};

/** Mark a saved address as the customer's primary delivery address. */
export const setPrimaryAddress = async (id) => {
  const res = await userRequest.patch(`/api/addresses/${id}/primary`);
  return res.data;
};
